<script setup lang="ts">
/**
 * UI-kit component
 * Category: Selects
 * Name: AppTableSelect
 * FIGMA: https://www.figma.com/design/1PxBoPBzVIsiNQGot6ka85/Tutor-s-space?node-id=7463-86917
 */
import type { AppTableSelectProps } from '../types/interfaces'

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/other'

import { useAppTableSelect } from '../composables/use-app-table-select.hook'

defineOptions({
  name: 'AppTableSelect',
})

const props = withDefaults(defineProps<AppTableSelectProps>(), {
  disabled: false,
})

const emit = defineEmits<{
  'update:model-value': [value: number]
}>()

const { handleChange } = useAppTableSelect({
  onChange: value => emit('update:model-value', value),
})
</script>

<template>
  <label :class="['app-table-select', { 'is-disabled': props.disabled }]">
    <select
      class="app-table-select__native"
      :value="modelValue"
      :disabled="disabled"
      @change="handleChange"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
    <IconContainer class="app-table-select__icon">
      <FontAwesomeIcon :icon="faChevronDown" />
    </IconContainer>
  </label>
</template>

<style lang="scss" scoped src="../styles/_app-table-select.scss" />
